// A small, uncompressed ZIP writer for the four text files in an OBS setup.
// UTF-8 names and CRC-32 make these ordinary ZIPs on Windows, macOS and Linux.
export function createStoredZip(files: Record<string, string>): Uint8Array<ArrayBuffer> {
  const encoder = new TextEncoder()
  const entries = Object.entries(files).map(([path, content]) => ({
    name: encoder.encode(path), data: encoder.encode(content),
  }))
  const localSize = entries.reduce((size, file) => size + 30 + file.name.length + file.data.length, 0)
  const centralSize = entries.reduce((size, file) => size + 46 + file.name.length, 0)
  const bytes = new Uint8Array(localSize + centralSize + 22)
  const view = new DataView(bytes.buffer)
  let offset = 0
  let central = localSize
  for (const { name, data } of entries) {
    let crc = 0xffffffff
    for (const byte of data) {
      crc ^= byte
      for (let bit = 0; bit < 8; bit++) crc = (crc >>> 1) ^ ((crc & 1) ? 0xedb88320 : 0)
    }
    crc = (crc ^ 0xffffffff) >>> 0
    view.setUint32(offset, 0x04034b50, true)
    view.setUint16(offset + 4, 20, true)
    view.setUint16(offset + 6, 0x0800, true)
    view.setUint16(offset + 12, 33, true) // 1980-01-01
    view.setUint32(offset + 14, crc, true)
    view.setUint32(offset + 18, data.length, true)
    view.setUint32(offset + 22, data.length, true)
    view.setUint16(offset + 26, name.length, true)
    bytes.set(name, offset + 30)
    bytes.set(data, offset + 30 + name.length)

    view.setUint32(central, 0x02014b50, true)
    view.setUint16(central + 4, 20, true)
    view.setUint16(central + 6, 20, true)
    view.setUint16(central + 8, 0x0800, true)
    view.setUint16(central + 14, 33, true)
    view.setUint32(central + 16, crc, true)
    view.setUint32(central + 20, data.length, true)
    view.setUint32(central + 24, data.length, true)
    view.setUint16(central + 28, name.length, true)
    view.setUint32(central + 42, offset, true)
    bytes.set(name, central + 46)
    offset += 30 + name.length + data.length
    central += 46 + name.length
  }
  view.setUint32(central, 0x06054b50, true)
  view.setUint16(central + 8, entries.length, true)
  view.setUint16(central + 10, entries.length, true)
  view.setUint32(central + 12, centralSize, true)
  view.setUint32(central + 16, localSize, true)
  return bytes
}
